import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const Bakery_Social = ({ pdfExportComponent, data, company, company2 }) => {
  // date_day
  // date_month
  // date_year
  // personal_info_name
  // personal_info_age
  // personal_info_house_No
  // personal_info_village_No
  // personal_info_lane
  // personal_info_road
  // personal_info_sub_district
  // personal_info_district
  // personal_info_province
  // personal_info_phone_number
  // detail_position
  // detail_start_date_day
  // detail_start_date_month
  // detail_start_date_year
  // detail_salary
  // detail_salary_word
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`แบบฟอร์มประกาศเรื่องการดำเนินการกับพนักงานที่ทุจริต - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="formId"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "125px",
                  right: "65px",
                  border: "1px",
                  borderStyle: "solid",
                  padding: "8px",
                  paddingBottom: "0px",
                  paddingTop: "5px",
                  width: "70px",
                  fontSize: "16px",
                  letterSpacing: 0.14,
                }}
              >
                <b className="docs-font-bold">HRM-054</b>
              </div>
              <div
                id="header"
                className="text-with-bold "
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "140px",
                  right: "47px",
                  fontSize: "15.5px",
                  width: "705px",
                  fontFamily: "THSarabun",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <b className="docs-font-bold">
                  หนังสือรับทราบการใช้ช้อมูลของบริษัทในสื่อออนไลน์ต่างๆ
                </b>
              </div>
              <div
                id="date"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "190px",
                  right: "76px",
                  fontSize: "18.2px",
                  // fontFamily: "angsaLight",
                  width: "647px",
                  letterSpacing: 0.14,
                  textAlign: "right",
                }}
              >
                วันที่...........เดือน....................................พ.ศ.................
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "215px",
                  right: "74px",
                  fontSize: "18px",
                  // fontFamily: "angsaLight",
                  width: "655px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                }}
              >
                <p />
                &nbsp;&emsp;&emsp;&emsp;หนังสือฉบับนี้ทำขึ้น ที่บริษัท
                {company?.name_th}&nbsp;
                <br />
                ข้าพเจ้านาย/นาง/นางสาว
                ….....……………………………………………......................……………………………...……....………….อายุ……..…….…….......ปี
                <br />
                อยู่บ้านเลขที่……….............……..........….หมู่ที่….............................ตรอก/ซอย…..............……..............……………...........…....……………..…..……
                <br />
                ถนน……………................................……………….............…........แขวง/ตำบล..............…………............................................………….........………..
                <br />
                เขต/อำเภอ……...……………………………............................……..จังหวัด……........…………….……..........................................….ซึ่งต่อไปในหนังสือนี้จะเรียกว่า
                " ลูกจ้าง "ขอทำหนังสือฉบับนี้ให้ไว้กับบริษัท {company?.name_th}
                &nbsp; ซึ่งต่อไปในหนังสือนี้จะเรียกรวมกันว่า “บริษัท”
                เพื่อเป็นการรับทราบและตกลงว่า
                <br />
                &nbsp;&emsp;&emsp;&emsp;โดยที่ปัจจุบันมีแหล่งให้บริการเครือข่ายทางสังคมเกิดขึ้นบนระบบเครือข่ายอินเทอร์เน็ตเป็นจำนวนมาก(Social
                Network) ตัวอย่างเช่น Facebook, Twitter, LinkedIn, Google Plus,
                MySpace, YouTube, Blog, Wiki ,Live รวมทั้งเว็บไซต์ต่างๆ
                ทั้งในประเทศและต่างประเทศ ที่เปิดให้บริการ file sharing, photo
                sharing, video sharing และกระดานข่าว (web board) เป็นต้น
                ซึ่งสื่อดังกล่าวเป็นเครื่องมือที่มีทั้งประโยชน์และโทษที่ควรระวัง
                โดยเฉพาะข้อมูลข่าวสารบางอย่างที่เผยแพร่ออกสู่สาธารณะไปแล้วอาจไม่สามารถเรียกกลับคืนได้
                และอาจก่อให้เกิดความเสียหายทั้งต่อตนเอง ต่อผู้อื่น และต่อบริษัท
                ดังนั้น เพื่อให้พนักงานในบริษัททุกท่าน
                สามารถใช้สื่อสังคมออนไลน์ได้อย่างมีประสิทธิภาพและเกิดประโยชน์สูงสุด
                ไม่เกิดผลเสียหายต่อบุคคลอื่นและบริษัทฯ
                จึงได้กำหนดนโยบายและแนวทางปฏิบัติสำหรับลูกจ้างผู้ที่ใช้สื่อสังคมออนไลน์
                (Social Network) ซึ่งพนักงานรับทราบและยินยอมปฏิบัติตาม
                มีรายละเอียดดังนี้
                <br />
                &nbsp;&emsp;&emsp;&emsp; 1. ลูกจ้างรับทราบเป็นอย่างดีว่า
                ข้อความหรือความเห็นที่เผยแพร่บน Social Network
                เป็นข้อความที่สามารถเข้าถึงได้โดยสาธารณะ
                ผู้เผยแพร่ต้องรับผิดชอบต่อการส่ง (Post) การแสดงความเห็น
                (Comment) การส่งต่อ (Share) ของตนเองทุกกรณี
                <br />
                &nbsp;&emsp;&emsp;&emsp; 2.
                ลูกจ้างต้องใช้ความระมัดระวังอย่างยิ่ง
                ในการเผยแพร่ความคิดเห็นที่อาจกระตุ้นหรือนำไปสู่การโต้แย้งที่รุนแรง
                เช่น เรื่องเกี่ยวกับการเมือง ศาสนา หรือเชื้อชาติ เป็นต้น
                <br />
                &nbsp;&emsp;&emsp;&emsp; 3. ลูกจ้างต้องรับทราบว่า
                พระราชบัญญัติว่าด้วยการกระทำผิดเกี่ยวกับคอมพิวเตอร์ พ.ศ.๒๕๕๐
                พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.๒๕๖๒ เกี่ยวกับการทำงาน
                และ ข้อบังคับของบริษัท
                มีผลผูกพันต่อการเผยแพร่ข้อมูลและแสดงความคิดเห็นบน Social Network
                ด้วย
                ซึ่งการฝ่าฝืนเงื่อนไขดังกล่าวถือว่าเป็นการประพฤติผิดวินัยอย่างร้ายแรงและเป็นการทำให้บริษัทฯ
                ได้รับความเสียหาย ซึ่งพนักงานอาจได้รับการลงโทษในขั้นร้ายแรง เช่น
                ไล่ออก พักงาน เป็นต้น
                <br />
                &nbsp;&emsp;&emsp;&emsp; 4.
                ลูกจ้างต้องไม่ละเมิดทรัพย์สินทางปัญญาของผู้อื่น
                หากต้องการกล่าวอ้างถึงแหล่งข้อมูลที่สนับสนุนข้อความของตน
                ควรอ้างอิงถึงแหล่งข้อมูลนั้นอย่างชัดเจน (เช่น
                ให้เครดิตเจ้าของเรื่องว่านำผลงานของบุคคลใดมาอ้างอิง)
                <br />
                &nbsp;&emsp;&emsp;&emsp; 5. ลูกจ้างพึงตระหนักว่า การใช้ Social
                Network นั้น การแบ่งแยกระหว่างเรื่องส่วนตัว
                และเรื่องหน้าที่การงาน เป็นสิ่งที่ทำได้ยาก หากประสงค์จะใช้
                Social Network
                เพื่อเผยแพร่ข้อมูลเกี่ยวกับเรื่องหน้าที่การงานหรือข้อมูลเกี่ยวกับหน่วยงาน
                ควรแยกบัญชีผู้ใช้ (Account) ระหว่างการใช้เพื่อเรื่องส่วนตัว
                และเรื่องหน้าที่การงานออกจากกัน ยกตัวอย่างเช่น การใช้ Facebook
                ของผู้ที่ทำหน้าที่ประชาสัมพันธ์ของส่วนงาน ควรมีการแยก Facebook
                Profile ที่ใช้สำหรับติดต่อกับเครือข่ายของตนในเรื่องส่วนตัว
                เรื่องครอบครัว ออกจาก Facebook Profile
                ที่ใช้ประชาสัมพันธ์ส่วนงาน หรืออาจตั้งเป็น Facebook Page
                ประจำส่วนงานขึ้นแทนที่จะใช้ Profile ส่วนตัว
                <br />
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="date_day"
                className="date day docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "188.5px",
                  right: "286px",
                  fontSize: "18.2px",
                  width: "30px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_day}
              </div>

              <div
                id="date_month"
                className="date month docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "188.5px",
                  right: "150px",
                  fontSize: "18.2px",
                  width: "106px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_month}
              </div>

              <div
                id="date_year"
                className="date year docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "188.5px",
                  right: "79px",
                  fontSize: "18.2px",
                  width: "46px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>

              <div
                id="personal_info_name"
                className="personal_info name docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "240px",
                  right: "210px",
                  fontSize: "18.2px",
                  width: "380px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "240.5px",
                  right: "109.6px",
                  fontSize: "18.5px",
                  width: "40px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_age}
              </div>

              <div
                id="personal_info_house_No"
                className="personal_info house_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "266.5px",
                  right: "574px",
                  fontSize: "18.5px",
                  width: "49px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_house_No}
              </div>
              <div
                id="personal_info_village_No"
                className="personal_info village_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "265.5px",
                  right: "455px",
                  fontSize: "18.5px",
                  width: "40px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_village_No}
              </div>

              <div
                id="personal_info_lane"
                className="personal_info lane docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "265.5px",
                  right: "225px",
                  fontSize: "18.5px",
                  width: "107px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_lane}
              </div>

              <div
                id="personal_info_road"
                className="personal_info road docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "292.5px",
                  right: "507px",
                  fontSize: "18.5px",
                  width: "180px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_road}
              </div>

              <div
                id="personal_info_sub_district"
                className="personal_info sub_district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "292.5px",
                  right: "215px",
                  fontSize: "18.5px",
                  width: "94px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_sub_district}
              </div>

              <div
                id="personal_info_district"
                className="personal_info district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "320.5px",
                  right: "500px",
                  fontSize: "18.5px",
                  width: "94px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_district}
              </div>

              <div
                id="personal_info_province"
                className="personal_info province docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "320.5px",
                  right: "192px",
                  fontSize: "18.5px",
                  width: "96px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_province}
              </div>
            </div>
          </div>
          <div
            id="page2"
            className="page-break"
            style={{ fontFamily: "THSarabun" ,position: "absolute", top: "1150px", right: "0%" }}
          >
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "relative",
                  // top: "1150px",
                  // right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
              <div
                id="content"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "0px",
                  fontFamily: "THSarabun",
                  right: "0px",
                }}
              >
                <div
                  id="paragraph1"
                  className="docs-font"
                  style={{
                    zIndex: 2,
                    position: "relative",
                    top: "125px",
                    right: "47px",
                    fontSize: "15.35px",
                    width: "705px",
                    letterSpacing: 0.14,
                    textAlign: "justify",
                    lineHeight: "20px",
                  }}
                >
                  &nbsp;&emsp;&emsp;&emsp;6. หากลูกจ้างประสงค์สร้าง Page หรือ
                  Account
                  ที่เป็นช่องทางในการเผยแพร่ข้อมูลอย่างเป็นทางการของส่วนงานหรือบริษัท
                  จะต้องแจ้งให้หัวหน้าส่วนงาน รับทราบอนุมัติก่อนดำเนินการ
                  แล้วแต่กรณี และต้องแจ้งรายชื่อของผู้ดูแล Page (Admin)
                  หรือเจ้าของ Account นั้นให้หัวหน้าส่วนงานรับทราบด้วย
                  และผู้ดูแลมีหน้าที่ต้องมอบสิทธิ์ในการดูแล Page หรือ Account
                  นั้นคืนแก่ส่วนงานหรือบริษัท เมื่อพ้นจากหน้าที่ที่ต้องดูแล
                  หรือพ้นสภาพจากการเป็นพนักงาน
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;7. การเผยแพร่ข้อมูล
                  หรือแสดงความเห็นที่อาจทำให้เข้าใจว่าเป็นความเห็นจากบริษัท
                  ส่วนงาน หรือหน่วยงาน ต้องมีการแสดงข้อความจำกัดความรับผิดชอบ
                  (Disclaimer) ว่า เป็นความเห็นส่วนตัว มิใช่ความเห็นของบริษัท
                  ส่วนงาน หรือหน่วยงานที่ตนสังกัด เว้นแต่จะเป็นความเห็นของบริษัท
                  ส่วนงานหรือหน่วยงานอย่างแท้จริง
                  หรือความเห็นนั้นได้รับอนุญาตจากผู้มีอำนาจที่เกี่ยวข้องแล้วแต่กรณี
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;8.
                  ห้ามลูกจ้างเผยแพร่ข้อมูลที่เป็นทรัพย์สินทางปัญญาของบริษัท
                  หรือข้อมูลที่ใช้ภายในบริษัท
                  ก่อนได้รับอนุญาตอย่างชัดเจนจากหัวหน้างานหรือกรรมการบริษัท
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;9. ห้ามลูกจ้างที่ปฏิบัติงานหน้าร้าน
                  หรือในบริษัทสำนักงานใหญ่ที่อาจใช้ตราสัญลักษณ์ (Logo) เช่น
                  ใส่เสื้อที่มีแบรนด์เครื่องหมายการค้า
                  เครื่องหมายบริการของบริษัทฯ
                  ถ่ายรูปส่วนตัวที่ทำให้เกิดความเสื่อมเสียแก่บริษัท
                  หรือใช้ตราสัญลักษณ์นั้นบนนามบัตรโดยไม่ได้รับอนุญาต
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;ทั้งนี้หากประสงค์ที่จะใช้ตราสัญลักษณ์นั้นเพื่อโฆษณา
                  ประชาสัมพันธ์ สินค้า ผลิตภัณฑ์ หรือการบริการใดๆ
                  จะต้องได้รับอนุญาตจากหัวหน้างานผู้มีอำนาจหรือกรรมการก่อนดำเนินการ
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;หากลูกจ้างฝ่าฝืนเงื่อนไขตรงข้อนี้เป็นเหตุให้เกิดความเสียหายแก่บริษัท
                  ลูกจ้างรับทราบว่าบริษัทมีสิทธิพิจารณาลงโทษด้วยการไล่ออก
                  เลิกจ้าง และจะต้องถูกฟ้องร้องดำเนินคดีตามกฎหมายโดยถึงที่สุด
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;หากลูกจ้างฝ่าฝืนเงื่อนไขตรงข้อนี้เป็นเหตุให้เกิดความเสียหายแก่บริษัท
                  ลูกจ้างรับทราบว่าบริษัทมีสิทธิพิจารณาลงโทษด้วยการไล่ออก
                  เลิกจ้าง และจะต้องถูกฟ้องร้องดำเนินคดีตามกฎหมายโดยถึงที่สุด
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;10.
                  ลูกจ้างพึงตระหนักถึงความรับผิดชอบในการเผยแพร่ข้อมูลเกี่ยวกับผู้รับบริการ
                  เนื่องจากผลของการเผยแพร่ข้อมูล อาจมีผลกระทบต่อผู้รับบริการ
                  หน่วยงานต่างๆ ได้โดยที่
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;10.1
                  ระมัดระวังอย่างยิ่งในการใช้ Social Network
                  ในการปฏิสัมพันธ์กับผู้รับบริการโดยเฉพาะไม่ควรใช้ Account
                  ที่ใช้สำหรับเรื่องส่วนตัวเพื่อการนี้
                  เนื่องจากไม่มีวิธีที่ได้ผลสมบูรณ์ในการปกปิดความลับของผู้รับบริการบน
                  Social Network
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;10.2
                  เคารพและระมัดระวังอย่างยิ่ง ไม่ให้มีการละเมิดความเป็นส่วนตัว
                  (Privacy) และความลับ (Confidentiality) ของผู้รับบริการ
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;10.3
                  หากลูกจ้างประสงค์ที่จะเผยแพร่ข้อมูลเพื่อการศึกษา เช่น รูปภาพ
                  หรือสื่ออื่นๆ ที่มาจากผู้รับบริการ
                  ต้องขออนุญาตจากผู้รับบริการนั้นก่อนเสมอ
                  และต้องลบข้อมูลที่อาจจะทำให้มีการทราบถึงตัวตนของผู้รับบริการนั้นให้หมด
                  เว้นแต่จะได้รับอนุญาตเป็นลายลักษณ์อักษรจากผู้รับบริการ
                  ทั้งนี้ให้รวมถึงการเผยแพร่ข้อมูลในกลุ่มปิดเฉพาะด้วย
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;10.4
                  หากพบเพื่อนร่วมหน่วยงาน ส่วนงาน หรือ บริษัทฯ ใช้ Social
                  Network เกี่ยวกับผู้รับบริการอย่างไม่เหมาะสม
                  ขอให้ตักเตือนโดยตรง หากไม่ได้รับการตอบสนองที่ดี
                  ให้แจ้งต่อผู้บังคับบัญชาของผู้นั้น
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;11.
                  ลูกจ้างตกลงแจ้งให้ผู้รับผิดชอบของหน่วยงาน ส่วนงาน
                  หรือบริษัททราบ หากพบว่ามีข้อความบน Social Network
                  ที่อาจทำให้เกิดความเสื่อมเสียชื่อเสียงของหน่วยงาน
                  ส่วนงานหรือบริษัทได้
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;12. ลูกจ้างตกลงศึกษาการใช้
                  “การตั้งค่าความเป็นส่วนตัว” หรือ “Privacy Settings”
                  ให้เข้าใจเป็นอย่างดี
                  และปรับแต่งการตั้งค่าความเป็นส่วนตัวให้เหมาะสมกับบริบท
                  การถูกละเมิดความเป็นส่วนตัวโดยไม่เหมาะสม
                  นอกเหนือจากส่งผลกระทบต่อตนเองแล้ว อาจส่งผลต่อหน่วยงาน
                  ส่วนงานและบริษัทได้ด้วย
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;13.ห้ามมิให้ลูกจ้างเผยแพร่รูปหรือข้อมูลใดๆขององค์กร
                  บน Social Network ทุกชนิดที่ก่อให้เกิดความเสียหายแก่บริษัท
                  ส่งผลให้เกิดภาพลักษณ์ที่ไม่ดีหรือในทางลบต่อบริษัท
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;14.
                  ห้ามลูกจ้างเผยแพร่ข่าวสารและโปรโมชั่นของทางบริษัทบน Social
                  Network ก่อนได้รับอนุญาตจากส่วนงาน หน่วยงานที่รับผิดชอบ หรือ
                  บริษัท
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;ข้าพเจ้าได้อ่านและรับทราบข้อความในหนังสือนี้โดยตลอดและเข้าใจอย่างละเอียดถี่ถ้วนแล้ว
                  จึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน
                  <br />
                  <br />
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................ลูกจ้าง
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                  ........................................................................
                  )
                  <br />
                  <br />
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พยาน
                  &nbsp;&nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พยาน
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;&emsp;(
                  .........................................................................
                  ) &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                  ........................................................................
                  )
                </div>
              </div>
            </div>

            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="personal_info_name2"
                className="personal_info name2 docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "844px",
                  right: "310px",
                  fontSize: "15.5px",
                  width: "187px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

Bakery_Social.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default Bakery_Social;
